interface CardItem {
  image: string;
  title: string;
  tag: string;
  desc: string;
}

const cards: CardItem[] = [
  {
    image: "https://readdy.ai/api/search-image?query=Vibrant%20anime%20illustration%20of%20a%20young%20adventurer%20with%20a%20sword%20in%20a%20fantasy%20landscape%2C%20warm%20orange%20and%20golden%20lighting%2C%20epic%20atmosphere%2C%20Japanese%20anime%20art%20style%2C%20dynamic%20composition%2C%20clean%20background%2C%20professional%20illustration&width=600&height=400&seq=card-anime-01&orientation=landscape",
    title: "剑与魔法",
    tag: "日漫·热血冒险",
    desc: "异世界冒险史诗巨作，少年剑士的成长之路，每周五更新。",
  },
  {
    image: "https://readdy.ai/api/search-image?query=Romantic%20anime%20scene%20with%20two%20characters%20under%20cherry%20blossoms%2C%20soft%20pink%20and%20warm%20coral%20tones%2C%20gentle%20spring%20atmosphere%2C%20Japanese%20high%20school%20setting%2C%20clean%20aesthetic%2C%20emotional%20moment&width=600&height=400&seq=card-anime-02&orientation=landscape",
    title: "夏日幻梦",
    tag: "日漫·恋爱校园",
    desc: "青春恋爱喜剧，第三季火热播出中，甜到心坎里。",
  },
  {
    image: "https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20anime%20illustration%20with%20spaceships%20and%20distant%20galaxies%2C%20cool%20blue%20and%20warm%20orange%20contrast%2C%20Chinese%20animation%20style%2C%20epic%20space%20battle%2C%20clean%20composition%2C%20digital%20art&width=600&height=400&seq=card-anime-03&orientation=landscape",
    title: "星域传说",
    tag: "国漫·科幻巨制",
    desc: "国产科幻动画标杆之作，画面品质全面升级，每周六更新。",
  },
  {
    image: "https://readdy.ai/api/search-image?query=Dark%20mysterious%20anime%20illustration%20of%20a%20detective%20in%20a%20rainy%20city%20at%20night%2C%20noir%20atmosphere%2C%20warm%20streetlights%20contrasting%20dark%20shadows%2C%20suspenseful%20mood%2C%20Japanese%20anime%20style%2C%20clean%20composition&width=600&height=400&seq=card-anime-04&orientation=landscape",
    title: "暗夜追踪者",
    tag: "日漫·悬疑推理",
    desc: "烧脑推理神作第二季全集上线，一口气追完12话。",
  },
  {
    image: "https://readdy.ai/api/search-image?query=Elegant%20Korean%20manhwa%20style%20illustration%20of%20two%20characters%20in%20formal%20attire%2C%20soft%20romantic%20lighting%2C%20warm%20peach%20and%20coral%20tones%2C%20modern%20city%20backdrop%2C%20clean%20aesthetic%2C%20professional%20digital%20art&width=600&height=400&seq=card-anime-05&orientation=landscape",
    title: "契约婚姻",
    tag: "韩漫·恋爱精选",
    desc: "契约开始的浪漫故事，番外篇独家上线51动漫。",
  },
  {
    image: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20fantasy%20anime%20illustration%20with%20floating%20palaces%20and%20magical%20creatures%2C%20warm%20golden%20and%20jade%20green%20tones%2C%20traditional%20architecture%2C%20mystical%20atmosphere%2C%20clean%20composition%2C%20digital%20art&width=600&height=400&seq=card-anime-06&orientation=landscape",
    title: "长安幻夜",
    tag: "国漫·古风奇幻",
    desc: "盛唐奇幻冒险，动画版定档8月，51动漫同步首播。",
  },
  {
    image: "https://readdy.ai/api/search-image?query=Comedy%20anime%20illustration%20with%20colorful%20chibi%20characters%20in%20everyday%20school%20life%20scenes%2C%20bright%20warm%20sunny%20day%2C%20playful%20atmosphere%2C%20Japanese%20anime%20style%2C%20clean%20composition%2C%20fun%20and%20energetic&width=600&height=400&seq=card-anime-07&orientation=landscape",
    title: "日常笑料部",
    tag: "日漫·搞笑日常",
    desc: "笑到停不下来的校园喜剧，治愈你的每一个疲惫时刻。",
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            推荐作品
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[500px] mx-auto">
            精选高分热门动漫，日韩国漫全覆盖，总有一部适合你
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 md:gap-6">
          {cards.map((card, idx) => (
            <div
              key={idx}
              className="group cursor-pointer bg-background-50 rounded-xl overflow-hidden transition-colors hover:bg-background-200/30"
            >
              <div className="relative w-full aspect-[3/2] overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 rounded-full text-xs font-medium bg-background-50/90 text-foreground-700 whitespace-nowrap">
                    {card.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base font-semibold text-foreground-800 group-hover:text-primary-500 transition-colors mb-2">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {card.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}